import {
  FETCH_PAYMENTS_REQUEST,
  FETCH_PAYMENTS_SUCCESS,
  FETCH_PAYMENTS_FAILURE,
  FETCH_PAYMENTS_COUNT_REQUEST,
  FETCH_PAYMENTS_COUNT_SUCCESS,
  FETCH_PAYMENTS_COUNT_FAILURE,
  FETCH_BILLING_REPORT_REQUEST,
  FETCH_BILLING_REPORT_SUCCESS,
  FETCH_BILLING_REPORT_FAILURE,
  FETCH_BILLING_REPORT_COUNT_REQUEST,
  FETCH_BILLING_REPORT_COUNT_SUCCESS,
  FETCH_BILLING_REPORT_COUNT_FAILURE
} from "../actions/paymentActions";

const initialState = {
  paymentsList: [],
  billingReportList: [],
  totalCount: 0,
  billingReportCount: 0, 
  isLoading: false,
  countLoading:false,
  billingReportLoading: false,
  billingCountLoading:false,
  error: null,
  billingReportError: null,
};

export const paymentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PAYMENTS_REQUEST:
      return { ...state, isLoading: true };

    case FETCH_PAYMENTS_SUCCESS:
      return { ...state, paymentsList: action.payload, isLoading: false };

    case FETCH_PAYMENTS_FAILURE:
      return { ...state, error: action.payload, isLoading: false };

    case FETCH_PAYMENTS_COUNT_REQUEST:
      return { ...state, countLoading: true };

    case FETCH_PAYMENTS_COUNT_SUCCESS:
      return { ...state, totalCount: action.payload, countLoading: false };

    case FETCH_PAYMENTS_COUNT_FAILURE:
      return { ...state, error: action.payload, countLoading: false };

    case FETCH_BILLING_REPORT_REQUEST:
      return { ...state, billingReportLoading: true };

    case FETCH_BILLING_REPORT_SUCCESS:
      return { ...state, billingReportList: action.payload, billingReportLoading: false };

    case FETCH_BILLING_REPORT_FAILURE:
      return { ...state, billingReportError: action.payload, billingReportLoading: false };

    case FETCH_BILLING_REPORT_COUNT_REQUEST:
      return { ...state, billingCountLoading: true };

    case FETCH_BILLING_REPORT_COUNT_SUCCESS:
      return { ...state, billingReportCount: action.payload, billingCountLoading: false };

    case FETCH_BILLING_REPORT_COUNT_FAILURE:
      return { ...state, billingReportError: action.payload, billingCountLoading: false };

    default:
      return state;
  }
};
